import { Observable } from 'rxjs';

/**
 * Наименования ошибок валидации
 */
export enum ValidationErrorKeys {
  DELIVERY_ADDRESS_REQUIRED = 'DELIVERY_ADDRESS_REQUIRED',
  PICKUP_ADDRESS_REQUIRED = 'PICKUP_ADDRESS_REQUIRED',
  TIME_SLOT_REQUIRED = 'TIME_SLOT_REQUIRED',
  PAYMENT_REQUIRED = 'PAYMENT_REQUIRED',
  CONTACTS_REQUIRED = 'CONTACTS_REQUIRED',
  DELIVERY_CITY_MISMATCH_WITH_CURRENT_CITY = 'DELIVERY_CITY_MISMATCH_WITH_CURRENT_CITY',
  SHOP_POSITION_NOT_AVAILABLE = 'SHOP_POSITION_NOT_AVAILABLE',
  MINIMUM_BONUS_VALUE = 'MINIMUM_BONUS_VALUE',
  BONUS_APPLYING_FAILED = 'BONUS_APPLYING_FAILED',
}

export type ValidationErrorKey = keyof typeof ValidationErrorKeys;

/**
 * Объект с ошибками валидации
 */
export type ValidationErrors = {
  [key in ValidationErrorKey]?: string;
};

/**
 * Интерфейс для сервисов которые участвуют в валидации
 */
export interface CheckoutValidator {
  /**
   * Должен возвращать статус валидации при каждом изменении значения
   */
  validate(): Observable<ValidationErrors>;
}
